/**
 * vendor/isomorphic/apps/isomorphic/src/app/shared/ecommerce/dashboard/stat-cards.tsx — its
 * "Revenue" card, fed by `GET /api/billing/reports/sales-trend?bucket=day` (invoicing-admin.md §9).
 * The headline is the API's own `totals.grandTotal`, the bars its own zero-filled daily buckets;
 * cancelled invoices are already excluded server-side. Nothing is summed here.
 */
import { PiInvoiceDuotone as InvoiceIcon } from "react-icons/pi";
import { TileBoundary } from "./TileBoundary";
import { TrendStatCard, UnreadableStatCard, countOf } from "./TrendStatCard";
import type { SalesTrendReport } from "../../lib/services/invoicing";
import { money } from "../../lib/services/ordering";
import { formatMoney } from "../../lib/format";

function unreadable(error: unknown) {
  return <UnreadableStatCard title="Invoiced" icon={<InvoiceIcon />} error={error} fallback="Could not be read — this is not the same as nothing invoiced." />;
}

export function InvoicedCard({ resolve, period }: { resolve: Promise<SalesTrendReport>; period: string }) {
  return (
    <TileBoundary resolve={resolve} errorFallback={unreadable} fallbackClassName="h-[196px]">
      {(report) => (
        <TrendStatCard
          title="Invoiced"
          metric={formatMoney(money(report.totals.grandTotal))}
          icon={<InvoiceIcon />}
          points={report.buckets.map((b) => ({ periodStart: b.periodStart, value: money(b.grandTotal) }))}
          format={formatMoney}
          period={period}
          footer={`${countOf(report.totals.invoiceCount, "invoice")}, cancelled excluded`}
        />
      )}
    </TileBoundary>
  );
}
